var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"create",attrs:{"justify-center":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-container',[_c('MultiImageBox',{attrs:{"remove":_vm.remove,"is-overview":_vm.isOverview,"add":false}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }